<template>
  <div class="cascader-options-single">
    <el-popover
      popper-class="cascader-single-popper"
      v-model="visible"
      trigger="click"
      placement="bottom-start"
      :disabled="disabled"
      @show="show"
      @hide="hide"
    >
      <div style="">
        <el-cascader-panel
          ref="cascader"
          :options="singleShowList"
          :props="props"
          v-model="checkValue"
          @change="tagMain($refs.cascader.getCheckedNodes())"
        />
      </div>
      <div slot="reference">
        <el-input
          class="zwx-input"
          :class="
            $zwxBase.verifyIsNotBlank(inputValue) && !disabled
              ? 'zwx-input-close'
              : null
          "
          v-model="inputValue"
          readonly
          :disabled="disabled"
          style="transition: width 2s;"
        >
          <i
            slot="suffix"
            v-if="!disabled"
            class="el-input__icon el-icon-circle-close"
            @click.stop=""
            @click="clearInput"
          />
          <i
            slot="suffix"
            class="el-input__icon el-icon-arrow-down"
            :class="visible ? ' zwx-input-up' : ''"
          />
        </el-input>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "CascaderOptionsSingle",
  model: {
    prop: "value",
    event: "propEvent"
  },
  components: {},
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    expandTrigger: { type: String, default: "click" },
    checkStrictly: { type: Boolean, default: false },
    dataNameFiled: { type: String, required: true },
    dataCodeFiled: { type: String, required: true },
    dataUpCodeFiled: { type: String, required: true },
    props: {
      type: Object,
      default() {
        return {
          value: this.dataCodeFiled,
          label: this.dataNameFiled,
          children: this.dataUpCodeFiled,
          expandTrigger: this.expandTrigger,
          checkStrictly: this.checkStrictly
        };
      }
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      api: this.$store.state.api,
      visible: false,
      singleShowList: this.options,
      inputValue: "",
      checkValue: this.value
    };
  },
  created() {},
  mounted() {},
  watch: {
    checkValue(val) {
      this.$emit("propEvent", val);
    },
    value: {
      handler() {
        if (this.value) {
          this.getLabel();
        }
      },
      immediate: true,
      deep: true
    },
    options(u) {
      this.singleShowList = u;
    }
  },
  computed: {},
  methods: {
    show() {
      this.$emit("show");
    },
    hide() {
      this.$emit("hide");
    },
    //tags内容处理
    tagMain(val) {
      this.inputValue = val[0].label;
      this.checkValue = val[0].value;
      this.visible = false;
      this.$emit("change", val[0].value);
    },
    getLabel() {
      if (this.value) {
        this.getlabelFul(this.singleShowList);
      }
    },
    getlabelFul(arr) {
      arr.forEach(child => {
        if (this.value === child[this.dataCodeFiled]) {
          this.inputValue = child[this.dataNameFiled];
        }
        if (this.$zwxBase.verifyIsNotBlank(child[this.dataUpCodeFiled])) {
          this.getlabelFul(child[this.dataUpCodeFiled]);
        }
      });
    },
    clearInput() {
      this.checkValue = null;
      this.inputValue = null;
      this.visible = false;
      this.$emit("change", null);
    },
    clear() {
      this.checkValue = "";
      this.inputValue = "";
    }
  }
};
</script>

<style lang="less" scoped>
.cascader-options-single {
  font-size: 14px !important;

  .el-icon-arrow-down:before {
    content: "\e6df" !important;
  }

  .el-icon-circle-close {
    display: none;
  }

  .el-icon-arrow-down {
    font-size: 14px !important;
  }

  /deep/ .zwx-input-close:hover {
    .el-icon-circle-close {
      display: inline-block;
    }

    .el-icon-arrow-down {
      display: none;
    }
  }

  .zwx-input-up {
    transform: rotateZ(-180deg);
    margin-left: -10px;
    margin-top: -1px;
  }

  /deep/ .el-popover__reference {
    position: relative;
  }
}
</style>

<style lang="less">
.cascader-single-popper {
  padding: 0;
  margin-top: unset !important;

  .el-cascader-panel.is-bordered {
    border: none;
  }

  .el-cascader-menu {
    color: #3a485e;
  }

  .el-cascader-node__label {
    font-size: 14px !important;
    padding: 0 12px !important;
  }

  .el-cascader-node {
    height: 32px !important;
    line-height: 32px !important;
    padding: unset !important;
  }

  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #316cf5 !important;
  }

  .el-cascader-node__prefix {
    display: none !important;
  }
}
</style>
